import "../../assets/Common.scss";
import "../../assets/fonts/font.css";
import React, { useEffect, useRef, useState } from "react";
import {
  moveToLogin,
  trackEvent,
  getChipsUid,
  getInsetBottom,
  showBottomSheet,
  getInsetTop,
  calc,
} from "../../js/chips-common.js";
import chipsApi from "../../js/chips-api";
import { showLoginBottomSheet } from "../VendingMachine";
import Lottie from "react-lottie";
import LottieConfetti from "./assets/confetti.json";
import LottieConfetti2 from "./assets/confetti2.json";
import reloadForChecksum from "../../util/ReloadChecksum";
import DateFormat from "../../util/DateFormat";
import CountUp from "react-countup";
import option1000 from "./assets/draw-1000.json";
import option2000 from "./assets/draw-2000.json";
import option4000 from "./assets/draw-4000.json";
import result from "./assets/result.json";

export default function VendingMachineDraw(props) {
  const dev = props.dev;
  const domain = dev
    ? `https://api.${dev}.chips.today`
    : "https://api.chips.today";

  const paths = window.location.pathname.split("/");
  const prizeGroupId = paths[paths.length - 1];

  const [prizeGroup, setPrizeGroup] = React.useState();
  const [isShowDraw, setShowDraw] = React.useState(false);
  const [prize, setPrize] = React.useState({});
  const [lottie, setLottie] = React.useState(false);
  const [lottie2, setLottie2] = React.useState(false);
  const [index, setIndex] = useState(null);
  const lotties = [option1000, option2000, option4000];
  const isLoaded = useRef(false);

  useEffect(() => {
    window.moveToLogin = moveToLogin;

    try {
      if (isLoaded.current) {
        return;
      }
      isLoaded.current = true;
      // eslint-disable-next-line no-undef
      chipsApp.setThemeColor("#000000");

      // eslint-disable-next-line no-undef
      chipsApp.showHeader(false);

      // eslint-disable-next-line no-undef
      chipsApp.setFullscreen(true);
    } catch (e) {}

    refresh();
    reloadForChecksum();
  }, []);

  useEffect(() => {
    try {
      // eslint-disable-next-line no-undef
      chipsApp.setThemeColor("#000000");

      // eslint-disable-next-line no-undef
      chipsApp.showHeader(false);

      // eslint-disable-next-line no-undef
      chipsApp.setFullscreen(true);
    } catch (e) {}
  }, [prizeGroup]);

  function refresh() {
    const now = new DateFormat().format("yyyy.MM.dd HH:mm:ss");
    if (now >= "2024.09.01 00:00:00") {
      try {
        showBottomSheet({
          icon: "https://cdn.chips.today/logic/images/2023/09/19/1695113982488-f687da0b-f2ef-4920-b2c6-d78ef7d5e582.png",
          title: "앗, 종료된 이벤트예요.",
          body: "다음 이벤트를 기대해 주세요!",
          secondary_button_text: "확인",
          secondary_button_style: "secondary",
          secondary_button_callback: "chipsApp.close()",
        });
      } catch (e) {}
      return;
    }

    chipsApi.request({
      method: "get",
      url: `${domain}/api/v1/benefit-events/vending_machine`,
      then: (response) => {
        const data = response.data;
        const prizeGroups = data.prize_groups;
        const prizeGroup = prizeGroups.find(
          (prizeGroup) => prizeGroup.id === parseInt(prizeGroupId),
        );
        const index = prizeGroups.findIndex(
          (prizeGroup) => prizeGroup.id === parseInt(prizeGroupId),
        );
        setPrizeGroup(prizeGroup);
        setIndex(index);
      },
    });
  }

  function draw() {
    const ms = Date.now();
    const delay = 2000;

    if (getChipsUid()) {
      setShowDraw(true);
      setLottie(false);
      setLottie2(false);

      chipsApi.request({
        method: "post",
        url: `${domain}/api/v1/prizes/${prizeGroup.id}/draw`,
        then: (response) => {
          const data = response.data;

          trackEvent("draw_result", {
            title: data?.prize_name,
          });

          setLottie2(true);
          setTimeout(
            () => {
              setPrize(data);
              setShowDraw(false);
              setLottie(true);
            },
            Math.max(0, delay - (Date.now() - ms)),
          );
        },
        error: (e) => {
          setShowDraw(false);
          setLottie(false);
          try {
            const data = e.response?.data;
            const code = data?.code || -1;
            switch (code) {
              case 2411:
                const landingUrl = encodeURIComponent(
                  `${domain}/api/v1/auth/cert/benefit/vending_machine`,
                );
                showBottomSheet({
                  icon: "https://cdn.chips.today/logic/images/2024/02/01/1706770372980-ceba2ea3-212b-45f9-97b1-87525803c770.png",
                  title: data.title,
                  body: data.message,
                  secondary_button_text: "닫기",
                  primary_button_text: "본인 인증하기",
                  primary_button_style: "primary",
                  primary_button_callback: `location.href="chips://web?url=${landingUrl}&title="`,
                });
                return true;

              case 2401:
                showBottomSheet({
                  icon: "https://cdn.chips.today/logic/images/2024/08/01/1722475345690-57a11d91-dbd7-447d-9b02-8da2d20413f8.png",
                  title: "앗! 별이 부족해요",
                  body: `칩스 포인트+에 참여하면<br/>포인트에 따라 별을 구할수 있어요!`,
                  secondary_button_text: "닫기",
                  primary_button_text: "별 구하기",
                  primary_button_style: "primary",
                  primary_button_callback: `location.href="chips://adison_offerwall"`,
                });
                return true;

              default:
                return false;
            }
          } catch (e) {}
          return false;
        },
      });
    } else {
      showLoginBottomSheet();
    }
  }

  return (
    <div
      style={{
        width: calc(360),
        visibility: index !== null ? "visible" : "hidden",
      }}
    >
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover"
      />

      <img
        src={
          prize && prize.prize_name
            ? "https://cdn.chips.today/logic/images/2024/07/29/1722243750463-304db11d-ee04-4d58-abd8-82d70b8966c5.png"
            : "https://cdn.chips.today/logic/images/2024/07/29/1722243830264-b70aa440-d222-4d06-b4a8-fdd29733b025.png"
        }
        style={{
          width: calc(360),
          height: "100vh",
          visibility: index !== null ? "visible" : "hidden",
        }}
      />

      <div
        style={{
          position: "fixed",
          visibility: !prize.prize_name ? "visible" : "hidden",
        }}
      >
        <div
          style={{
            position: "fixed",
            top: getInsetTop(),
            width: calc(360),
            zIndex: 2,
          }}
        >
          <div
            className="active-small"
            style={{
              position: "absolute",
              top: 0,
              left: calc(20),
              width: calc(36),
              height: calc(60),
              display: "flex",
              justifyContent: "center",
            }}
            onClick={() => {
              try {
                // eslint-disable-next-line no-undef
                chipsApp.close();
              } catch (e) {
                window.history.back();
              }
            }}
          >
            <img
              style={{
                width: calc(36),
                height: calc(36),
              }}
              src="https://cdn.chips.today/logic/images/2024/07/26/1721968137732-c646d8e5-c97b-4a9e-8c7b-b3c446ab1404.png"
            />
          </div>
        </div>

        <div
          className="scrollbar-hidden"
          style={{
            // background: `${backggroundColors[index]}`,
            width: "100vw",
            position: "fixed",
            top: 0,
            left: 0,
            bottom: 0,
            zIndex: 0,
            overflowY: "scroll",
            overflowX: "hidden",
            paddingBottom: calc(120, getInsetBottom()),
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginTop: calc(60, getInsetTop()),
              backgroundColor: "transparent",
            }}
          >
            <div
              style={{
                width: calc(290),
                height: calc(290),
              }}
            >
              <Lottie
                options={{
                  loop: true,
                  autoplay: true,
                  animationData: lotties[index],
                  rendererSettings: {
                    preserveAspectRatio: "xMidYMid meet",
                  },
                }}
                isClickToPauseDisabled={true}
              />
            </div>
          </div>

          {prizeGroup && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "baseline",

                color: "#1F215A",
                textAlign: "center",
                fontFamily: "Gmarket Sans",
                fontSize: calc(83),
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: calc(93),
                background:
                  "linear-gradient(180deg, #FFFFFF 0%, #59FCFE 50%, #59ABFE 75%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                textShadow: "0px 5px 20px 0px rgba(0, 0, 0, 0.25)",
              }}
            >
              {parseInt(prizeGroup.prize_items[0].name) || parseInt(0)}
              <div
                style={{
                  fontFamily: "Gmarket Sans",
                  fontSize: calc(40),
                  fontStyle: "normal",
                  fontWeight: 700,
                  background:
                    "linear-gradient(180deg, #FFFFFF 0%, #59FCFE 50%, #59ABFE 75%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  textShadow: "0px 5px 20px 0px rgba(0, 0, 0, 0.25)",
                }}
              >
                원
              </div>
            </div>
          )}

          {prizeGroup && (
            <div>
              <div
                style={{
                  marginTop: calc(14),
                  fontFamily: "Gmarket Sans",
                  fontSize: calc(22),
                  fontStyle: "normal",
                  fontWeight: 500,
                  color: "#FFFFFF",
                  lineHeight: calc(34),
                }}
              >
                별 {prizeGroup.draw_value || 0}
                개를 구하면
              </div>
              <div
                style={{
                  fontFamily: "Gmarket Sans",
                  fontSize: calc(22),
                  fontStyle: "bold",
                  fontWeight: 700,
                  color: "#FFFFFF",
                  lineHeight: calc(34),
                }}
              >
                {prizeGroup.name}으로 교환해 드려요!
              </div>
            </div>
          )}
        </div>
      </div>
      <div
        style={{
          position: "absolute",
          bottom: calc(0),

          backgroundColor: "#6c00ff",
          width: calc(360),
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "top",
          visibility: !prize.prize_name ? "visible" : "hidden",
        }}
      >
        <div
          style={{
            objectFit: "contain",
            width: calc(360),
            height: calc(70),
            marginBottom: getInsetBottom(),
          }}
          className="active-only-alpha"
          onClick={() => {
            if (prizeGroup) {
              trackEvent("draw", {
                id: prizeGroup.id.toString(),
                title: prizeGroup.name,
              });
              draw();
            }
          }}
        >
          <img
            src="https://cdn.chips.today/logic/images/2024/07/29/1722244840268-1d0bc657-4d5e-4728-857b-93896503e1a1.png"
            style={{
              width: calc(360),
              height: calc(70),
              marginBottom: getInsetBottom(),
            }}
          />
        </div>
      </div>
      {
        // DESCRIPTION
      }
      <div
        className="scrollbar-hidden"
        style={{
          position: "absolute",
          width: "100vw",
          height: "100vh",
          overflow: "scroll",
          justifyContent: "center",
          visibility: isShowDraw ? "visible" : "hidden",
        }}
      >
        <div
          className="scrollbar-hidden"
          style={{
            position: "absolute",
            width: "100vw",
            top: 0,
            left: 0,
            bottom: 0,
            overflowX: "hidden",
            overflowY: "scroll",
            paddingBottom: calc(120, getInsetBottom()),
            visibility:
              !isShowDraw && prize && prize.prize_name ? "visible" : "hidden",

            display: "flex",
            // justifyContent: "center",
          }}
        >
          <div
            style={{
              position: "fixed",
              top: getInsetTop(),
              width: calc(360),
              zIndex: 2,
            }}
          >
            <div
              className="active-small"
              style={{
                position: "absolute",
                top: 0,
                left: calc(20),
                width: calc(36),
                height: calc(60),
                display: "flex",
                justifyContent: "center",
              }}
              onClick={() => {
                try {
                  // eslint-disable-next-line no-undef
                  chipsApp.close();
                } catch (e) {
                  window.history.back();
                }
              }}
            >
              <img
                style={{
                  width: calc(36),
                  height: calc(36),
                }}
                src="https://cdn.chips.today/logic/images/2024/07/26/1721968137732-c646d8e5-c97b-4a9e-8c7b-b3c446ab1404.png"
              />
            </div>
          </div>
          {/*<Lottie*/}
          {/*  options={{*/}
          {/*    loop: false,*/}
          {/*    autoplay: false,*/}
          {/*    animationData: LottieConfetti,*/}
          {/*    rendererSettings: {*/}
          {/*      preserveAspectRatio: "xMidYMid slice",*/}
          {/*    },*/}
          {/*  }}*/}
          {/*  isClickToPauseDisabled={true}*/}
          {/*  isStopped={!lottie}*/}
          {/*  style={{*/}
          {/*    position: "absolute",*/}

          {/*    width: calc(600),*/}
          {/*    height: calc(600),*/}
          {/*  }}*/}
          {/*/>*/}
          <Lottie
            options={{
              loop: false,
              autoplay: false,
              animationData: LottieConfetti2,
              rendererSettings: {
                scaleMode: "noScale",
                preserveAspectRatio: "xMidYMid slice",
              },
            }}
            isClickToPauseDisabled={true}
            isStopped={!lottie2}
            style={{
              position: "absolute",
              width: "100vw",
              height: "100vh",
            }}
          />
          <div
            style={{
              marginTop: calc(56, getInsetTop()),
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: result,
                rendererSettings: {
                  preserveAspectRatio: "xMidYMid meet",
                },
              }}
              isClickToPauseDisabled={true}
            ></Lottie>
          </div>
          {prize && prize.prize_name && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "baseline",
                color: "#1F215A",
                textAlign: "center",
                fontFamily: "Gmarket Sans",
                fontSize: calc(83),
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: calc(93),
                background:
                  "linear-gradient(180deg, #FFFFFF 0%, #59FCFE 50%, #59ABFE 75%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                textShadow: "0px 5px 20px 0px rgba(0, 0, 0, 0.25)",
              }}
            >
              <CountUp
                start={0}
                end={prize.prize_name}
                duration={1}
                delay={0.5}
              />
              <div
                style={{
                  fontFamily: "Gmarket Sans",
                  fontSize: calc(40),
                  fontStyle: "normal",
                  fontWeight: 700,
                  lineHeight: calc(93),
                  background:
                    "linear-gradient(180deg, #FFFFFF 0%, #59FCFE 50%, #59ABFE 75%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  textShadow: "0px 5px 20px 0px rgba(0, 0, 0, 0.25)",
                }}
              >
                원
              </div>
            </div>
          )}

          <span
            style={{
              color: "#FFFFFF",
              textAlign: "center",
              fontFamily: "Gmarket Sans",
              fontSize: calc(26),
              fontStyle: "normal",
              fontWeight: 700,
              lineHeight: calc(34),
              marginTop: calc(28),
              zIndex: 1,
            }}
          >
            포인트 적립 완료!
          </span>
          <span
            style={{
              color: "#FFFFFF",
              textAlign: "center",
              fontFamily: "Gmarket Sans",
              fontStyle: "normal",
              fontSize: calc(20),
              fontWeight: 500,
              lineHeight: calc(34),
              zIndex: 1,
            }}
          >
            칩스에서 알뜰한 쇼핑하세요!
          </span>
        </div>

        <div
          className="active-only-alpha"
          style={{
            position: "absolute",
            bottom: calc(0),
            width: calc(360),
            flexShrink: 0,
            backgroundColor: "#000000",
            justifyContent: "center",
            visibility:
              !isShowDraw && prize && prize.prize_name ? "visible" : "hidden",
          }}
          onClick={() => {
            trackEvent("rewards", {
              title: prize?.prize_name,
            });
            window.location.href = "chips://reward_history";
          }}
        >
          <img
            src="https://cdn.chips.today/logic/images/2024/07/29/1722243637611-fd787817-9684-403a-a742-26228da93401.png"
            style={{
              width: calc(360),
              height: calc(70),
              marginBottom: getInsetBottom(),
            }}
          />
        </div>
      </div>
    </div>
  );
}
